import React from "react";
import { useState } from "react";
import { resetPasswordAsync } from "../../features/userSlice";
import { useDispatch } from "react-redux";

const ResetPassword = ({ vals }) => {
  const { show, setShow, setModal } = vals;
  const dispatch = useDispatch();

  const [state, setState] = useState({
    password: "",
    cpassword: "",
  });
  const Authorization = JSON.parse(
    sessionStorage.getItem("userData")
  ).Authorization;

  const [isSubmit, setIsSubmit] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const handleInputChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  React.useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      dispatch(resetPasswordAsync({ Authorization, password: state.password }));
      setShow(false);
    }
  }, [formErrors, isSubmit]);

  const validate = () => {
    let errors = {};
    if (state.password.trim() === "") {
      errors.password = "Password is Required!";
    } else if (state.password.length < 6 && errors.password === undefined) {
      errors.password = "Password Must Be Greater Than 6!";
    } else if (state.password.length > 16) {
      errors.password = "Password Must Be Less Than  16!";
    }

    if (state.cpassword.trim() === "") {
      errors.cpassword = "Confirm Password Is Required";
    } else if (
      errors?.cpassword === undefined &&
      state.password !== state.cpassword
    ) {
      errors.cpassword = "Password Must be Same";
    }
    return errors;
  };

  const checkErrors = (e) => {
    let check = validate();
    let name = e.target.name;

    if (name in check) {
      setFormErrors({ ...formErrors, [name]: check[name] });
    } else {
      setFormErrors({ ...formErrors, [name]: "" });
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate());
    setIsSubmit(true);
  };

  return (
    <>
      <div
        className={`modal my-auto ${show ? "d-flex" : "d-none"}`}
        id="loginModal"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body">
              <form className="cmn-form login-form change-password-form">
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShow(false);
                  }}
                ></button>

                <div className="form-title">
                  <h2>Reset Password</h2>
                </div>

                <div className="form-group position-relative mb-0">
                  <div className="form-group">
                    <div className="eye-paassword"></div>
                    <label htmlFor="password">New Password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="password"
                      placeholder="Password"
                      value={state.password}
                      onChange={handleInputChange}
                      // onFocus={(e) => setErrors(e)}
                      onBlur={(e) => checkErrors(e)}
                    />
                    <p className="text-danger">{formErrors?.password}</p>
                  </div>
                </div>

                <div className="form-group position-relative mb-0">
                  <div className="form-group">
                    <div className="eye-paassword"></div>
                    <label htmlFor="password">Confirm Password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="cpassword"
                      placeholder="Confirm Password"
                      value={state.cpassword}
                      onChange={handleInputChange}
                      // onFocus={(e) => setErrors(e)}
                      onBlur={(e) => checkErrors(e)}
                    />
                    <p className="text-danger">{formErrors?.cpassword}</p>
                  </div>
                </div>

                <div className="form-group">
                  <input
                    type="submit"
                    className="cmn-btn form-btn"
                    value="Submit"
                    onClick={handleFormSubmit}
                  />
                </div>
                {/*  */}
              </form>
            </div>
          </div>
          {/*  */}
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
